<template>
    <video class="video hero-video w-full h-full object-cover absolute left-0 top-0" muted loop autoplay playsinline data-keepplaying>
        <source src="../../../assets/videos/autopilot-hero.mp4" type="video/mp4">
    </video>
</template>

<script>
    export default {
        name: "AutopilotBgVideo",
        mounted() {

        }
    }
</script>

<style scoped>

</style>